module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/hr-f3f2e25c45a219c68654040bb674a6c4.svg";